import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const ArrowDownIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         {...props}
         viewBox="0 0 24 24"
         fill="none"
      >
         <path
            d="M10.796 18.4298L0.521739 7.20176C-0.173914 6.5 -0.173914 5.27193 0.521738 4.57018C1.16388 3.80994 2.28762 3.80994 2.92977 4.57018L11.9732 14.4532L21.0702 4.57018C21.7124 3.80994 22.8361 3.80994 23.4783 4.57018C24.1739 5.27193 24.1739 6.5 23.4783 7.20175L13.204 18.4298C12.5619 19.1901 11.4381 19.1901 10.796 18.4298Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default ArrowDownIcon
